/**
 * Централизованный реестр React Query keys.
 *
 * Все queryKey должны жить здесь, а не разбросанными литералами по компонентам.
 * Это:
 *   - устраняет рассинхрон при invalidateQueries (легко промахнуться буквой);
 *   - даёт автодополнение и единое место для рефакторинга;
 *   - явно показывает зависимости (`as const` фиксирует tuple-форму).
 */
export const queryKeys = {
  chat: {
    threads: () => ['chat', 'threads'] as const,
    messages: (threadId: string | null | undefined) => ['chat', 'messages', threadId] as const,
  },

  templates: {
    all: () => ['templates'] as const,
    bySchool: (schoolId: string | null | undefined) => ['templates', schoolId] as const,
    bySchoolAndKind: (schoolId: string | null | undefined, kind: string | null | undefined) =>
      ['templates', schoolId, kind] as const,
  },

  school: {
    byId: (schoolId: string | null | undefined) => ['school', schoolId] as const,
    teachers: (schoolId: string | null | undefined) => ['school-teachers', schoolId] as const,
    teacherStats: (schoolId: string | null | undefined, teacherId: string) =>
      ['school-teacher-stats', schoolId, teacherId] as const,
  },

  billing: {
    tiers: () => ['billing-tiers'] as const,
    subscription: (schoolId: string | null | undefined) =>
      ['billing-subscription', schoolId] as const,
    subscriptionAll: () => ['billing-subscription'] as const,
    payments: (schoolId: string | null | undefined) => ['billing-payments', schoolId] as const,
    paymentsAll: () => ['billing-payments'] as const,
  },

  audit: {
    recent: (limit: number) => ['audit-recent', limit] as const,
  },

  parent: {
    children: () => ['parent-children'] as const,
    grades: (studentId: string) => ['parent-grades', studentId] as const,
    attendance: (studentId: string) => ['parent-attendance', studentId] as const,
  },

  student: {
    context: (studentId: string | null | undefined) => ['student-context', studentId] as const,
  },

  classCtx: {
    composition: (classId: string | null | undefined) => ['class-composition', classId] as const,
    compositionQuarter: (classId: string | null | undefined) =>
      ['class-composition-quarter', classId] as const,
  },

  llm: {
    usage: () => ['llm-usage'] as const,
  },

  list: {
    students: () => ['students-list'] as const,
    classes: () => ['classes-list'] as const,
  },
} as const
